export const isPresentNode = (value)=>{
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    return value != null && value !== false && value !== '';
};
